import { useEffect, useState } from 'react';
import { userManager } from '../../apps/Authentication/userManager';

// Mirrors when OIDCAuthHeadersLink sends a token, so callers can hold queries the gateway would 401.
export default () => {
    const [isSignedIn, setIsSignedIn] = useState(false);

    useEffect(() => {
        if (!userManager) return undefined;

        let active = true;
        const onUserLoaded = user => active && setIsSignedIn(!!user);
        const onUserUnloaded = () => active && setIsSignedIn(false);

        // Subscribe before reading so a user loaded mid-read isn't missed.
        userManager.events.addUserLoaded(onUserLoaded);
        userManager.events.addUserUnloaded(onUserUnloaded);
        userManager.getUser().then(onUserLoaded);

        return () => {
            active = false;
            userManager.events.removeUserLoaded(onUserLoaded);
            userManager.events.removeUserUnloaded(onUserUnloaded);
        };
    }, []);

    return isSignedIn;
};
